<header class="site-header">
  <div class="header-inner">
    <div class="header-row">
      <div class="left-group">
        <button
          type="button"
          class="menu-button"
          (click)="menuClicked.emit()"
          [attr.aria-label]="'shared.navigation_bar.toggle_sidebar' | translate"
        >
          <svg
            class="menu-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M4 6h16" />
            <path d="M4 12h16" />
            <path d="M4 18h16" />
          </svg>
        </button>

        <a class="logo-link" routerLink="/homepage">
          <img
            class="logo"
            [src]="logoUrl()"
            [attr.alt]="'shared.navigation_bar.logo_alt' | translate"
            crossorigin="anonymous"
          />
        </a>

        <nav class="main-nav">
          @for (link of links(); track link.route) {
            <a
              class="nav-link"
              [class.active]="url().includes(link.route)"
              [routerLink]="'/' + link.route"
              [queryParams]="link.queryParams"
            >
              {{ link.label }}
            </a>
          }
        </nav>

        @if (showCreate()) {
          <a class="create-link" mat-flat-button color="primary" routerLink="/upload">
            <mat-icon>add</mat-icon>
            {{ "shared.navigation_bar.create" | translate }}
          </a>
        }
      </div>

      <div class="right-group">
        <dev-org-dropdown *devUserOnly class="dropdown" />
        <app-profile-dropdown class="dropdown" />
      </div>
    </div>
  </div>
</header>

<app-breadcrumbs />
<app-navigating-indicator />
